import FriendlyTime from "app/components/shared/FriendlyTime";
import { StyledUnderline } from "../../shared/styles";
import { FlakyTest } from "../../shared/type";
import TestStateBadge from "./TestStateBadge";
import TestLocation from "../../shared/Metadata/TestLocation";

export type FlakyRowProps = {
  isFlaky?: boolean;
};

type Props = FlakyRowProps & {
  flakyTest: FlakyTest;
};

const FlakyTestRow = ({ flakyTest, isFlaky = true }: Props) => {
  return (
    <li className="row-link__container">
      <div className="ta-panel-row grid-cols-[auto_7rem_7rem_7rem] lg:grid-cols-[auto_7rem_14rem_17rem]">
        <div className="main-section">
          <div className="flex gap-1">
            {flakyTest.state && <TestStateBadge state={flakyTest.state} />}
          </div>

          <a
            href={flakyTest.test_path}
            className="block max-w-full truncate font-medium text-inherit no-underline hover:underline focus:underline"
            title={flakyTest.description}
          >
            {flakyTest.description}
          </a>

          <TestLocation location={flakyTest.location} locationUrl={flakyTest.location_url} />
        </div>

        {isFlaky && (
          <>
            <div className="text-center">
              {flakyTest.instances}
              <span className="sr-only"> flaky instances</span>
            </div>

            <div className="relative z-[1]">
              <span className="sr-only">First occurrence</span>
              <StyledUnderline as={FriendlyTime} value={flakyTest.first_occurrence_at} />
            </div>
          </>
        )}

        <div className="flex items-center justify-between">
          <div className="relative z-[1]">
            <span className="sr-only">Latest instance at</span>
            <StyledUnderline as={FriendlyTime} value={flakyTest.latest_occurrence_at} />
          </div>
        </div>
      </div>
    </li>
  );
};

export default FlakyTestRow;
